import { render } from "./TeachDetailPage.vue?vue&type=template&id=1a60f348&scoped=true"
import script from "./TeachDetailPage.vue?vue&type=script&lang=js"
export * from "./TeachDetailPage.vue?vue&type=script&lang=js"

import "./TeachDetailPage.vue?vue&type=style&index=0&id=1a60f348&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a60f348"]])

export default __exports__